module.exports = __webpack_public_path__ + "img/cone.706f9e03.svg";